export const PROFILE = '[Profile]';

export const UPDATE_USER_REQUEST = `${PROFILE} UPDATE_USER_REQUEST`;
export const UPDATE_USER_SUCCESS = `${PROFILE} UPDATE_USER_SUCCESS`;
export const UPDATE_USER_ERROR = `${PROFILE} UPDATE_USER_ERROR`;
export const CHANGE_PASSWORD_REQUEST = `${PROFILE} CHANGE_PASSWORD_REQUEST`;
export const CHANGE_PASSWORD_SUCCESS = `${PROFILE} CHANGE_PASSWORD_SUCCESS`;
export const CHANGE_PASSWORD_ERROR = `${PROFILE} CHANGE_PASSWORD_ERROR`;
